export default __webpack_public_path__ + "static/media/dartboard3.18ca472c.png";